var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecycleBin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 321,
    viewBox: "0 0 214 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.025 295.648C182.111 309.377 173.735 320.611 164.412 320.611H50.2442C40.921 320.611 32.545 309.377 31.6316 295.648L13.6197 24.9924C12.7063 11.2635 19.5876 0.0292969 28.9107 0.0292969H185.746C195.069 0.0292969 201.951 11.2625 201.037 24.9924L183.025 295.648Z",
    fill: "#2C6FB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.898 56.3198V290H183.898L197.898 56.3198H106.898Z",
    fill: "#1E4F91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.814 0.0302734C205.277 0.0302734 213.759 12.5814 213.759 28.0623C213.759 43.5442 205.276 56.0942 194.814 56.0942H19.8423C9.37998 56.0952 0.897705 43.5452 0.897705 28.0623C0.897705 12.5814 9.37998 0.0302734 19.8423 0.0302734H194.814Z",
    fill: "#2C6FB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.445 0.319824C209.218 0.319824 213.898 12.8565 213.898 28.3198C213.898 43.7841 209.218 56.3198 203.445 56.3198H106.898C106.898 38.2765 106.898 28.7874 106.898 28.7874C106.898 13.3241 106.898 17.3004 106.898 0.319824H203.445Z",
    fill: "#245FA3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.836 132.075L123.044 93.3198L91.3639 93.3218L91.363 93.3208L72.4839 126.898L86.6917 125.042L92.4778 139.211L107.361 112.744L124.883 143.904L114.593 150.004L143.917 153.837L155.346 125.845L144.836 132.075Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6944 146.369L39.8977 185.74L39.9004 185.739L55.7425 214.354V214.355H93.5073L84.8363 202.464L93.8977 190.039H64.1274L81.6515 158.386L91.9421 164.582L80.5111 136.148L51.1828 140.04L61.6944 146.369Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.506 213.952H159.07L159.066 213.95L174.897 185.676H174.898L156.029 151.975L150.493 165.588L135.656 163.64L150.53 190.207H115.506V177.961L97.6218 202.21L115.507 226.458L115.506 213.952Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleBin);
export default __webpack_public_path__ + "static/media/recycle-bin.d5842c8a9e410bdcd4c311c3b3007e6f.svg";
export { ForwardRef as ReactComponent };